"use strict";
exports.__esModule = true;
exports.defaultItemTemplate = void 0;
exports.defaultItemTemplate = "\n    <span class=\"highlight\">{{word}}</span>\n";
